export enum MessageTransport {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
  LOG_PHONE_CALL = 'LOG_PHONE_CALL',
  BOOP = 'BOOP',
}

export enum Type {
  Direct = 'DIRECT',
  Contact = 'CONTACT',
  Client = 'CLIENT',
  Business = 'BUSINESS',
}
